const ACTION_TYPE = "LOGIN";
export const LOGIN_SUCCESS = `${ACTION_TYPE}/LOGIN_SUCCESS`;
export const LOGIN_FAIL = `${ACTION_TYPE}/LOGIN_FAIL`;
export const LOGOUT_SUCCESS = `${ACTION_TYPE}/LOGOUT_SUCCESS`;
export const GET_USER = `${ACTION_TYPE}/GET_USER`;
export const GET_USERS = `${ACTION_TYPE}/GET_USERS`;
